(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('change', async (e) => {
    const box = e.target.closest('[data-cart-warranty]');
    if (!box) return;
    box.disabled = true;
    const body = box.checked
      ? { url: '/cart/add.js', data: { items: [{ id: parseInt(box.dataset.cartWarranty, 10), quantity: 1 }] } }
      : { url: '/cart/change.js', data: { id: box.dataset.line, quantity: 0 } };
    await fetch(body.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body.data) });
    window.location.reload();
  });
  // Up to `max` tiles in the cart become free sample lines (shipping only).
  // Above `max`, sample lines turn back into the real tile variants at full price.
  class CartSampleRule extends HTMLElement {
    async connectedCallback() {
      const { product, variant, max } = this.dataset;
      const limit = parseInt(max, 10) || 4;
      const cart = await fetch('/cart.js').then((r) => r.json());
      const isSample = (i) => String(i.product_id) === product;
      const isAddon = (i) => i.product_type === 'Warranty';
      const tileCount = cart.items.filter((i) => !isAddon(i)).reduce((n, i) => n + i.quantity, 0);
      const updates = {};
      let items = [];
      if (tileCount <= limit) {
        cart.items.filter((i) => !isSample(i) && !isAddon(i)).forEach((i) => {
          updates[i.key] = 0;
          items.push({
            id: parseInt(variant, 10),
            quantity: i.quantity,
            properties: {
              Design: i.product_title,
              Colour: i.variant_title || '',
              _variant: String(i.variant_id),
              _image: i.image ? `${i.image}${i.image.includes('?') ? '&' : '?'}width=240` : '',
            },
          });
        });
      } else {
        cart.items.filter((i) => isSample(i) && i.properties && i.properties._variant).forEach((i) => {
          updates[i.key] = 0;
          items.push({ id: parseInt(i.properties._variant, 10), quantity: i.quantity });
        });
      }
      if (!items.length) return;
      // Merge identical lines so the same tile is not listed twice.
      items = Object.values(items.reduce((acc, it) => {
        const k = it.properties ? it.properties._variant : it.id;
        if (acc[k]) acc[k].quantity += it.quantity; else acc[k] = it;
        return acc;
      }, {}));
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      window.location.reload();
    }
  }
  if (!customElements.get('cart-sample-rule')) customElements.define('cart-sample-rule', CartSampleRule);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.cells = [...this.querySelectorAll('.plp__cell')];
      this.cells.forEach((cell) => {
        cell.colours = JSON.parse(cell.querySelector('[data-colours]').textContent);
        const img = cell.querySelector('.product-card__img');
        cell.defaultImg = img && { src: img.src, srcset: img.srcset };
        cell.defaultHref = cell.querySelector('.product-card').href;
      });
      this.colour = null;
      this.buildColours();
      this.addEventListener('click', (e) => {
        const c = e.target.closest('[data-colour]');
        if (c) {
          this.colour = this.colour === c.dataset.colour ? null : c.dataset.colour;
          this.apply();
        }
        if (e.target.closest('[data-clear]')) this.clear();
        const tog = e.target.closest('[data-toggle-filters]');
        if (tog) {
          this.classList.toggle('is-open');
          tog.setAttribute('aria-expanded', this.classList.contains('is-open'));
        }
        const cols = e.target.closest('[data-cols]');
        if (cols) {
          this.querySelector('[data-grid]').style.setProperty('--cols', cols.dataset.cols);
          this.querySelectorAll('[data-cols]').forEach((b) => b.setAttribute('aria-pressed', b === cols));
        }
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-status]')) this.apply();
      });
      this.querySelector('[data-colour-search]').addEventListener('input', (e) => {
        const q = e.target.value.trim().toLowerCase();
        this.querySelectorAll('[data-colour-list] li').forEach((li) => { li.hidden = q && !li.dataset.name.includes(q); });
      });
    }

    buildColours() {
      const map = new Map();
      this.cells.forEach((cell) => {
        Object.entries(cell.colours).forEach(([name, v]) => {
          const key = name.trim();
          if (!map.has(key)) map.set(key, { img: v.i, count: 0 });
          map.get(key).count += 1;
        });
      });
      const list = this.querySelector('[data-colour-list]');
      [...map.entries()].sort((a, b) => b[1].count - a[1].count || a[0].localeCompare(b[0])).forEach(([name, v]) => {
        const li = document.createElement('li');
        li.dataset.name = name.toLowerCase();
        li.innerHTML = '<button type="button" aria-pressed="false"><img alt="" width="32" height="32" loading="lazy"><span></span><span></span></button>';
        const btn = li.querySelector('button');
        btn.dataset.colour = name;
        if (v.img) li.querySelector('img').src = v.img.replace('width=800', 'width=80');
        else li.querySelector('img').remove();
        btn.children[btn.children.length - 2].textContent = name;
        btn.lastElementChild.textContent = v.count;
        list.append(li);
      });
    }

    apply() {
      const sale = this.querySelector('[data-status="sale"]').checked;
      const stock = this.querySelector('[data-status="stock"]').checked;
      const order = this.querySelector('[data-status="order"]').checked;
      let shown = 0;
      this.cells.forEach((cell) => {
        const match = this.colour ? cell.colours[this.colour] || Object.entries(cell.colours).find(([k]) => k.trim() === this.colour)?.[1] : null;
        const ok = (!this.colour || match) &&
          (!sale || cell.dataset.sale === 'true') &&
          (!stock || cell.dataset.available === 'true') &&
          (!order || cell.dataset.backorder === 'true');
        cell.hidden = !ok;
        if (ok) shown += 1;
        const img = cell.querySelector('.product-card__img');
        const link = cell.querySelector('.product-card');
        if (match && match.i && img) {
          img.srcset = '';
          img.src = match.i;
          link.href = match.u;
        } else if (img && cell.defaultImg) {
          img.src = cell.defaultImg.src;
          img.srcset = cell.defaultImg.srcset;
          link.href = cell.defaultHref;
        }
      });
      this.querySelectorAll('[data-colour]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.colour === this.colour));
      const active = this.colour || sale || stock || order;
      this.querySelector('.plp__bar [data-clear]').hidden = !active;
      this.querySelector('[data-none]').hidden = shown > 0;
      this.querySelector('[data-count]').textContent = `Showing ${shown} of ${this.cells.length} designs${this.colour ? ` in ${this.colour}` : ''}`;
    }

    clear() {
      this.colour = null;
      this.querySelectorAll('[data-status]').forEach((c) => { c.checked = false; });
      this.apply();
    }
  }
  if (!customElements.get('collection-filters')) customElements.define('collection-filters', CollectionFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colour-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cguide').forEach((root) => {
    const rows = JSON.parse(root.querySelector('[data-colours]').textContent).filter(Boolean);
    const groups = new Map();
    rows.forEach((r) => {
      const key = r.c.trim().toLowerCase().replace(/[-\s]+/g, ' ');
      if (!groups.has(key)) groups.set(key, { name: r.c.trim(), img: r.i, items: [] });
      groups.get(key).items.push(r);
    });
    const list = [...groups.values()].sort((a, b) => b.items.length - a.items.length || a.name.localeCompare(b.name));
    const grid = root.querySelector('[data-grid]');
    list.forEach((g) => {
      const card = document.createElement('article');
      card.className = 'cguide__card';
      card.dataset.name = g.name.toLowerCase();
      card.innerHTML = '<img alt="" loading="lazy" width="300" height="300"><div class="cguide__body"><h2></h2><span class="cguide__count"></span><div class="cguide__designs"></div></div>';
      card.querySelector('img').src = g.img;
      card.querySelector('h2').textContent = g.name;
      card.querySelector('.cguide__count').textContent = `Available in ${g.items.length} design${g.items.length === 1 ? '' : 's'}`;
      const d = card.querySelector('.cguide__designs');
      g.items.forEach((it) => {
        const a = document.createElement('a');
        a.href = it.u;
        const thumb = document.createElement('img');
        thumb.src = it.i.replace('width=300', 'width=80').replace('height=300', 'height=80');
        thumb.alt = '';
        thumb.width = 40;
        thumb.height = 40;
        thumb.loading = 'lazy';
        const label = document.createElement('span');
        label.textContent = it.t;
        a.append(thumb, label);
        d.append(a);
      });
      grid.append(card);
    });
    root.querySelector('[data-search]').addEventListener('input', (e) => {
      const q = e.target.value.trim().toLowerCase();
      grid.querySelectorAll('.cguide__card').forEach((c) => { c.hidden = q && !c.dataset.name.includes(q); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installs-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.igal__filters [data-filter]');
    if (!btn) return;
    const root = btn.closest('.igal');
    const f = btn.dataset.filter;
    root.querySelectorAll('[data-filter]').forEach((b) => b.setAttribute('aria-pressed', b === btn));
    root.querySelectorAll('.igal__item').forEach((it) => {
      it.hidden = f !== 'all' && !it.dataset.styles.split(' ').includes(f);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.piecesInput = this.querySelector('[data-qty-pieces]');
      this.tileSqft = parseFloat(this.dataset.tileSqft) || 4;
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-index]')) this.onOptionChange();
        if (event.target.matches('[data-mode]')) this.onModeChange();
        if (event.target.matches('[data-qty-input]')) this.syncQty(true);
      });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-calc-length], [data-calc-width]')) this.onCalc();
        if (event.target.matches('[data-qty-input]')) this.syncQty();
      });
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-qty]');
        if (step) {
          this.qtyInput.value = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + parseInt(step.dataset.qty, 10));
          this.syncQty();
        }
        const apply = event.target.closest('[data-calc-apply]');
        if (apply) {
          this.querySelector('[data-mode][value="piece"]').checked = true;
          this.qtyInput.value = apply.dataset.calcApply;
          this.onModeChange(false);
        }
        const thumb = event.target.closest('[data-thumb]');
        if (thumb) this.showSlide(parseInt(thumb.dataset.thumb, 10));
        const nav = event.target.closest('[data-gallery-nav]');
        if (nav) this.showSlide(this.currentSlide() + parseInt(nav.dataset.galleryNav, 10));
      });
      this.addEventListener('submit', (event) => {
        const check = this.querySelector('[data-warranty-check]');
        if (!check || !check.checked) return;
        event.preventDefault();
        this.addWithWarranty(check);
      });
      this.addEventListener('scroll', (event) => {
        if (!event.target.matches('[data-stage]')) return;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.markThumb(this.currentSlide()), 80);
      }, true);
      this.syncQty();
    }

    tiers() {
      const d = this.querySelector('[data-tiers]').dataset;
      return { box: +d.box || 10, t2: +d.t2, p2: +d.p2, t3: +d.t3, p3: +d.p3 };
    }

    // Visible input counts pieces or boxes; the cart always gets pieces.
    onModeChange(convert = true) {
      const { box } = this.tiers();
      const boxMode = this.querySelector('[data-mode]:checked').value === 'box';
      const n = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
      if (convert) this.qtyInput.value = boxMode ? Math.max(1, Math.ceil(n / box)) : n * box;
      this.querySelector('[data-qty-label]').textContent = boxMode ? 'Boxes' : 'Pieces';
      this.syncQty();
    }

    syncQty(clamp = false) {
      const { box, t2, p2, t3, p3 } = this.tiers();
      const boxMode = this.querySelector('[data-mode]:checked').value === 'box';
      const n = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
      if (clamp) this.qtyInput.value = n;
      const pcs = boxMode ? n * box : n;
      this.piecesInput.value = pcs;

      const area = Math.round(pcs * this.tileSqft);
      const boxes = Math.floor(pcs / box);
      const rest = pcs % box;
      this.querySelector('[data-qty-note]').textContent = boxMode
        ? `${pcs} pieces · covers ${area} sq ft`
        : `covers ${area} sq ft` + (boxes ? ` · ${boxes} box${boxes > 1 ? 'es' : ''}${rest ? ` + ${rest} pcs` : ''}` : '');

      const tier = pcs >= t3 ? 3 : pcs >= t2 ? 2 : 1;
      this.querySelectorAll('[data-tier-row]').forEach((row) => row.toggleAttribute('data-active', +row.dataset.tierRow === tier));

      this.querySelector('[data-save-fill]').style.width = `${Math.min(100, (pcs / t3) * 100)}%`;
      this.querySelectorAll('[data-save-stop]').forEach((s) => s.toggleAttribute('data-reached', pcs >= +s.dataset.saveStop));
      this.querySelector('[data-save-msg]').innerHTML =
        pcs < t2 ? `Add <strong>${t2 - pcs} more pieces</strong> to unlock ${p2}% off`
        : pcs < t3 ? `<strong>${p2}% off unlocked.</strong> Add ${t3 - pcs} more for ${p3}% off`
        : `<strong>${p3}% off unlocked.</strong> Best price on this order`;
    }

    async addWithWarranty(check) {
      const warrantyId = parseInt(check.closest('[data-warranty-variant]').dataset.warrantyVariant, 10);
      const btn = this.querySelector('[data-add]');
      btn.disabled = true;
      const cart = await fetch('/cart.js').then((r) => r.json());
      const items = [{ id: parseInt(this.idInput.value, 10), quantity: parseInt(this.piecesInput.value, 10) || 1 }];
      if (!cart.items.some((i) => i.variant_id === warrantyId)) items.push({ id: warrantyId, quantity: 1 });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (res.ok) window.location.href = '/cart';
      else btn.disabled = false;
    }

    currentSlide() {
      const stage = this.querySelector('[data-stage]');
      return stage ? Math.round(stage.scrollLeft / stage.clientWidth) : 0;
    }

    showSlide(index) {
      const stage = this.querySelector('[data-stage]');
      const count = stage.querySelectorAll('[data-slide]').length;
      const i = (index + count) % count;
      stage.querySelectorAll('video').forEach((v) => v.pause());
      stage.scrollTo({ left: i * stage.clientWidth });
      this.markThumb(i);
    }

    markThumb(i) {
      this.querySelectorAll('[data-thumb]').forEach((t) => {
        const on = parseInt(t.dataset.thumb, 10) === i;
        t.setAttribute('aria-current', on);
        if (on) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - t.parentElement.clientHeight / 2 + t.clientHeight / 2 });
      });
    }

    onOptionChange() {
      const selected = [...this.querySelectorAll('[data-option-index]:checked')].map((input) => input.value);
      const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
      selected.forEach((value, i) => {
        const label = this.querySelector(`[data-option-label="${i}"]`);
        if (label) label.textContent = value;
      });
      if (!variant) return;
      this.idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      this.updateFromServer(url);
    }

    async updateFromServer(url) {
      const fetchUrl = new URL(url);
      fetchUrl.searchParams.set('section_id', this.closest('.shopify-section').id.replace('shopify-section-', ''));
      const html = await fetch(fetchUrl).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const swap = () => {
        ['[data-price]', '[data-add]', '[data-sku]', '[data-gallery]', '[data-tiers]'].forEach((selector) => {
          const next = doc.querySelector(selector);
          const current = this.querySelector(selector);
          if (next && current) current.replaceWith(next);
        });
        this.syncQty();
      };
      if (document.startViewTransition) document.startViewTransition(swap);
      else swap();
    }

    onCalc() {
      const length = parseFloat(this.querySelector('[data-calc-length]').value);
      const width = parseFloat(this.querySelector('[data-calc-width]').value);
      const out = this.querySelector('[data-calc-result]');
      if (!length || !width) {
        out.textContent = '';
        return;
      }
      const area = length * width;
      const tiles = Math.ceil((area / this.tileSqft) * 1.1);
      out.innerHTML = `${area.toFixed(0)} sq ft → <strong>${tiles} tiles</strong> (incl. 10% extra). <button type="button" data-calc-apply="${tiles}">Use ${tiles}</button>`;
    }
  }

  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sample-drawer"]) return;
  try {
    
  class SampleDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-sample-open], a[href="#sample"], a[href$="/#sample"]')) return;
        e.preventDefault();
        this.dialog.showModal();
      });
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog || e.target.closest('[data-close]')) this.dialog.close();
      });
    }
  }

  if (!customElements.get('sample-drawer')) customElements.define('sample-drawer', SampleDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tile-calculator"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tcalc').forEach((root) => {
    const form = root.querySelector('.tcalc__form');
    const out = (k) => root.querySelector(`[data-out="${k}"]`);
    const rate = parseFloat(root.dataset.rate) || 1;
    const sym = root.dataset.symbol;
    const sqftPerTile = parseFloat(root.dataset.sqft) || 4;
    const money = (paise) => `${sym}${(paise / rate / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    const run = () => {
      const f = new FormData(form);
      const l = parseFloat(f.get('length'));
      const w = parseFloat(f.get('width'));
      if (!l || !w) {
        ['area', 'tiles', 'cost'].forEach((k) => { out(k).textContent = '–'; });
        return;
      }
      const toSqft = f.get('unit') === 'm' ? 10.7639 : 1;
      const area = l * w * toSqft;
      const tiles = Math.ceil((area / sqftPerTile) * (1 + parseFloat(f.get('waste'))));
      out('area').textContent = `${area.toFixed(0)} sq ft`;
      out('tiles').textContent = tiles;
      const sel = form.elements.design;
      const price = parseInt(sel.value, 10);
      out('cost').textContent = price ? money(price * tiles) : 'Pick a design';
      const link = out('link');
      if (price) {
        link.href = sel.selectedOptions[0].dataset.url;
        link.textContent = `Order ${tiles} tiles`;
      } else {
        link.textContent = 'Browse designs';
      }
    };
    form.addEventListener('input', run);
    form.addEventListener('change', run);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.play().catch(() => {}); else e.target.pause(); });
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-ugc] video').forEach((v) => io.observe(v));
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-sound]');
      if (!btn) return;
      const v = btn.parentElement.querySelector('video');
      v.muted = !v.muted;
      btn.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
